import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-folder-model",
  "use": "icon-leo-folder-model-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-folder-model\">\r\n<g transform=\"translate(-113.571 -113.571) scale(1.221818)\">\r\n<path d=\"M160 192h320v640H160V192zm64 64v512h192V256H224z\" />\r\n  <path d=\"M544 288h320v128H544V288zm0 192h320v128H544V480zm0 192h224v128H544V672z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-folder-model.svg
// module id = 6794
// module chunks = 396